import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import LogoNu from '../../assets/img/contact-img.png';

const EventBanner = ({language}) => {
    return (
        <section className='event-banner'>
            <div className="event-header">
                <h1>{language === "Chinese"? "活動辦法" : "Event Guide"}</h1>
            </div>
            <Container>
                <Row className="align-items-center">
                    <Col className="event-banner-bx mb-5">
                        <h2>L’Étape環法自行車挑戰賽-紐崔萊 • 日月潭站</h2>
                        <h2>【L’Étape Sun Moon Lake by Tour de France, presented by Nutrilite】</h2>
                        <img className='align-self-center mt-5' src={LogoNu} alt="" />
                        <p className='mt-5'>{language === "Chinese"? "你也想感受環法傳奇嗎？" : "Want to experience the legend of the Tour de France?"}</p>
                        <p>{language === "Chinese"? "你能想像有一天與環法車手一樣，馳騁在全世界各地的絕美自行車路線！" : "Imagine riding the world's most beautiful cycling routes, just like the Tour de France pros!"}</p>
                        <p>{language === "Chinese"? "2026年第三屆日月潭環法官方認證挑戰賽 L’Étape by Tour de France，環法專家認證路線、移植國際賽事規格、現場環法小鎮歷史村，共同見證體驗環法氛圍、前所未有報名尊寵禮盒，還有機會與傳奇車手見面聽他分享環法歷程與故事等，今年秋天最受矚目的自行車賽事等你來挑戰！" : "In 2026, L’Étape by Tour de France, the official Tour de France-certified series, returns to Sun Moon Lake for its third edition. Ride a route certified by Tour de France experts, run to international race standards, and soak up the Tour atmosphere in the on-site Race Village with its Tour de France history exhibition. Enjoy an unprecedented registration gift box, plus the chance to meet a Tour de France legend and hear their stories from the race. The most anticipated cycling event of the fall is waiting for you!"}</p>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default EventBanner